import { Component, Input, OnInit } from '@angular/core';
import { PigeonholeService } from 'src/app/core/data-sources/v3/pigeonhole/pigeonhole.service';
import { PigeonholeMisplacedPallets } from 'src/models/Pigeonhole';

@Component({
  selector: 'app-pigeonhole-misplaced',
  templateUrl: './pigeonhole-misplaced.component.html',
  styleUrls: ['./pigeonhole-misplaced.component.scss']
})
export class PigeonholeMisplacedComponent implements OnInit {
  @Input() id: string;
  pallets: PigeonholeMisplacedPallets[] = [];
  constructor(private pigeonholeService: PigeonholeService) { }

  ngOnInit() {
    if (this.id) {
      this.getMisplacedPallets(this.id);
    }
  }

  async getMisplacedPallets(id: string) {
    this.pallets = await this.pigeonholeService.getPigeonholeMisplacedPallets(id);
  }
}
